import { Card, Image, message } from "antd";
import { useEffect, useMemo } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import BasicLayout from "../../../components/BasicLayout";
import FallBack from "../../../components/common/FallBack/FallBack";
import Notification from "../../../components/common/Notification";
import { CustomTab } from "../../../components/common/Tab/Tab";
import { getSingleBrand } from "../../../store/actions/products/brands/brand.action";
import { getSingleProductSecondaryCategory } from "../../../store/actions/products/secondaryCategory/categories.action";

const ViewCategory = (props) => {
	const categoryId = +props.match.params.id;
	const dispatch = useDispatch();
	const history = useHistory();
	const category = useSelector((state) => state.productSecondaryCategory.category || {});
	const brandData = useSelector((state) => state.brand.brand || {});
	const brandId = category?.primaryCategory?.brandId;
	const location = useLocation();
	const softdelete = new URLSearchParams(location.search).get("soft-delete");
	const admin = useSelector((state) => state.admin.admin || []);

	const permissionArr = useMemo(() => {
		if (admin && admin.template) {
			const { permissions } = admin.template;
			return permissions;
		} else if (admin && admin.accessLevel === "superAdmin") {
			return "all";
		}
		return [];
	}, [admin]);

	useEffect(() => {
		dispatch(getSingleProductSecondaryCategory(categoryId, softdelete)).catch((err) => {
			Notification("error", err, "", "topRight");
			history.push("/products/secondary/categories");
		});
	}, [dispatch, history, softdelete, categoryId]);

	useEffect(() => {
		if (brandId) {
			dispatch(getSingleBrand(brandId));
		}
	}, [dispatch, categoryId, brandId]);
	let data = [];
	let isOrderEmpty = Object.keys(category).length === 0;
	if (!isOrderEmpty) {
		data = [
			{ title: "Id", description: category?.id },
			{
				title: "Name",
				description: category?.name,
			},
			{
				title: "Code",
				description: category?.code,
			},
			{
				title: "Brand",
				description: brandData.name,
			},
			{
				title: "Primary Category Name",
				description: category?.primaryCategory?.name,
			},
			{
				title: "Received",
				description: new Date(category?.createdAt).toLocaleString(),
			},
			{
				title: "Image",
				description: (
					<div className="gallery-images">
						<div className="image-holder-container">
							<Image width={250} height={180} src={category?.url} />
						</div>
					</div>
				),
			},
		];
	}

	const handleError = (error) => {
		message.error(error.message);
	};
	let operationData = {
		deletedBy: category?.deletedBy,
		updatedBy: category?.updatedBy,
		restoredBy: category?.restoredBy,
	};

	return (
		<BasicLayout accessLevel={props.accessLevel}>
			<ErrorBoundary FallbackComponent={FallBack} onError={handleError}>
				<Card className="enqiury-detail-card" data-testid="enqiury-detail-card">
					<CustomTab
						update={
							permissionArr === "all"
								? "true"
								: permissionArr?.products?.productSecondaryCategories.filter(
										(item) => item === "update"
								  )?.length > 0
								? "true"
								: false
						}
						data={data}
						operationData={operationData}
						redirectUrl={`/products/secondary/categories/update/${categoryId}`}
					/>
				</Card>
			</ErrorBoundary>
		</BasicLayout>
	);
};

export default ViewCategory;
